import React, { useState } from "react";
import styled from "styled-components";
import { imageZoomEffect, TitleStyles } from "./ReusableStyles";

// --- Shared Styles ---
import {
  CardInfo,
  Description,
  ButtonContainer,
  StyledButton,
  BannerContainer,
  Banner,
} from "./CardStyles";

// --- Image Imports ---

import InventoryAlertSystem from "../assets/InventoryAlertSystem.jpg";
import OrderFulfillmentTracker from "../assets/OrderFulfillmentTracker.jpg";
import InvoiceGen from "../assets/InvoiceGen.jpg";
import TheArchetypeBrandTransformer from "../assets/TheArchetypeBrandTransformer.png";
import NewStorySpinnerLogo from "../assets/newStorySpinnerLogo.png";
import landscapeImg from "../assets/landscapeImgNew.jpg";
import cleaningHomecare from "../assets/cleaningHomecare.jpg";
import electricianHandyman from "../assets/electricianHandyman.jpg";
import mechanicRepairman from "../assets/mechanicRepairman.jpg";
import authorWriter from "../assets/authorWriter.jpg";
import artistCreators from "../assets/artistCreators.jpg";
import smallshopMarketplace from "../assets/smallshopMarketplaceNew.jpg";
import showcaseRealEstate from "../assets/showcaseRealEstate.jpg";
import TermsofserviceMagnizying from "../assets/termsofserviceMagnizying.jpg";
import StrategicBusinessPlanner from "../assets/StrategicBusinessPlanner.png";
import showcaseWorkflowAutomation from "../assets/showcaseWorkflowAutomation.png";
import showcaseCustomerService from "../assets/showcaseCustomerService.png";
import showcaseFinancialServices from "../assets/showcaseFinancialServices.png";
import showcaseHealthcareAgents from "../assets/showcaseHealthcareAgents.png";
import RebelAdvisorIMG from "../assets/RebelAdvisorIMG.png";
import BusinessRebrandingTool from "../assets/BusinessRebrandingTool.png";
import SpectrumsAI from "../assets/spectrumsAI.png";
import HomeschoolGuideAI from "../assets/HomeschoolGuideAI.png";
import tutorAI from "../assets/TutorAI.jpg";
import SpecializedAI from "../assets/SpecializedAI.jpg";
import CustomerServiceAI from "../assets/CustomerServiceAI.jpg";
import LawIMG from "../assets/law.png";
import FormRAGIMG from "../assets/FormRAGIMG.jpg";
import GUMROADailanding from "../assets/ailanding.png";
import GUMROADaiChatbotTemplates from "../assets/16e2c651-146e-40a8-bd32-bf5a56fc0d1f.png";
import HuggyfaceArchetypeFinder from "../assets/HuggyfaceArchetypeFinder.jpg";
import VoicesOfTheMagiScreenshot from "../assets/voiceofthemagi.png";
import Mindpulse150 from "../assets/mindpulse150.jpg";
import Archédex from "../assets/archédex.png";
import ArchetypeAPI from "../assets/archetypeAPI.jpg";

// --- Video Card Import ---
import { VideoCard } from "./VideoCard";
import LocalServiceBusinessPost from "./LocalServiceInsights";

// --- Video URL (served from public/) ---
const demoVideo = "/videos/homeschoolGuideAI-founder-video.mp4"; // Must be in public/videos/

// --- Styled Section ---
const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  ${TitleStyles};

  .ReactSectionCards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    justify-items: center;
    margin: 4rem 0;

    .service {
      display: flex;
      flex-direction: column;
      height: 28rem;
      width: 100%;
      max-width: 300px;
      background: #0a0a0a;
      border: 1px solid #44fd47;
      border-radius: 8px;
      overflow: hidden;
      padding: 1rem;
      transition: box-shadow 0.3s ease;

      &:hover {
        box-shadow: 0 0 15px rgba(68, 253, 71, 0.5);
      }

      .description-container {
        min-height: 5rem;
        width: 100%;
        padding: 0.5rem;
        background: rgba(0, 0, 0, 0.5);
      }

      .image {
        height: 13rem;
        width: 100%;
        position: relative;
        border-radius: 5px;
        overflow: hidden;
        ${imageZoomEffect};

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          filter: brightness(60%);
        }
      }
    }
  }

  @media screen and (max-width: 1080px) {
    .ReactSectionCards {
      grid-template-columns: repeat(2, 1fr);
      gap: 1.5rem;
    }
  }

  @media screen and (max-width: 690px) {
    .ReactSectionCards {
      grid-template-columns: 1fr;
      gap: 1.5rem;
      justify-items: center;

      .service {
        max-width: 300px;
        margin: 0 auto;
      }
    }
  }
`;

// --- NEW: Inquire button handler ---
const handleInquire = (cardName) => {
  const subject = encodeURIComponent(`Inquiry about ${cardName}`);
  const body = encodeURIComponent(
    `Hi James,\n\nI'm interested in "${cardName}". Could you tell me more about:\n\n- Pricing\n- Features\n- How it works\n\nThanks!`
  );
  window.location.href = `mailto:james@studiovoice2fly.com?subject=${subject}&body=${body}`;
};

// --- Data ---
const data = [
  {
    image: SpectrumsAI,
    videoSrc: demoVideo,
    name: "Homeschool Guide AI",
    desc: "Personalized lesson plans, social stories, and tools designed for neurodivergent-friendly homeschooling.",
    link: "https://homeschoolguide.ai",
    hasBanner: false,
    bannerText: "Web App",
    githubOnly: false,
    useFeaturedButton: true,
  },
  {
    image: GUMROADaiChatbotTemplates,
    name: "AI Chatbot Templates",
    desc: "5 customizable HTML chatbot landing templates, each with an optional AI-driven chat experience that begins after a visitor submits a short form.",
    link: "https://jrq3rqstudio.gumroad.com/l/ailanding",
    hasBanner: false,
    bannerText: "For $ale",
    githubOnly: false,
  },
  {
    image: Archédex,
    name: "Archédex",
    desc: "Your personal AI guide inside The Archetype Academy. Chat interface powered by your archetype profile.",
    link: "https://archetype-academy-nexus.web.app/archedex-demo",
    hasBanner: true,
    bannerText: "Concept",
    isFeatured: false,
  },
  {
    image: Mindpulse150,
    name: "MindPulse150 – Archetype Academy Gateway",
    desc: "Big Five personality test. Your score unlocks your complementary archetype and entry to the Academy Nexus MVP.",
    link: "https://archetype-academy-nexus.web.app/assessment",
    hasBanner: true,
    bannerText: "Concept",
    isFeatured: false,
  },
  {
    image: ArchetypeAPI,
    name: "Archetype API",
    desc: "JSON API delivering 12 Jungian archetypes with full psychological profiles. Built for writers, game devs & character systems.",
    link: "https://us-central1-archetype-builder-api.cloudfunctions.net/api/archetypes/",
    hasBanner: true,
    bannerText: "API",
    isFeatured: false,
  },
  {
    image: VoicesOfTheMagiScreenshot,
    name: "Voice of the Magi",
    desc: "Chat with the three Biblical Magi. A quiet Epiphany journey built with Grok.",
    link: "https://voices-of-the-magi.web.app/",
    hasBanner: true,
    bannerText: "Demo Tool",
    isFeatured: false,
  },
  {
    image: HuggyfaceArchetypeFinder,
    name: "AI Archetype Finder",
    desc: "Archetype concept demo.",
    link: "https://huggingface.co/spaces/jrq3rq/AI-Archetype-Finder",
    hasBanner: true,
    bannerText: "Huggyface",
    isFeatured: true,
  },
  {
    image: FormRAGIMG,
    name: "form-rag-js",
    desc: "One AI form for any business—powered by Grok. Structured templates replace prompts for quotes, chats, and scheduling.",
    link: "https://www.npmjs.com/package/form-rag-js",
    hasBanner: true,
    bannerText: "NPM Package",
    githubOnly: false,
    downloadOnly: true
  },
  {
    image: smallshopMarketplace,
    name: "AI Chatbots for Small Businesses",
    desc: "Convert visitors to buyers with smart sales conversations.",
    // link: false,
    // link2: false,
    // hasBanner: false,
    // githubOnly: false,
    // hideButtons: false,
    link: "https://jrq3rqstudio.gumroad.com/l/ailanding",
    hasBanner: false,
    bannerText: "For $ale",
    githubOnly: false,
  },
   {
    image: InvoiceGen,
    name: "Automated Invoice Generator",
    desc: "Speed up invoicing and reduce human error.",
    link: false,
    link2: false,
    hasBanner: false,
    bannerText: "SMBs",
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: OrderFulfillmentTracker,
    name: "Order Fulfillment Tracker",
    desc: "Visualize, track, and manage order pipelines in real time.",
    link: false,
    link2: false,
    hasBanner: false,
    bannerText: "SMBs",
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: InventoryAlertSystem,
    name: "Inventory Alert System",
    desc: "Stay ahead of stockouts and overstock with proactive alerts.",
    link: false,
    link2: false,
    hasBanner: false,
    bannerText: "SMBs",
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  // {
  //   image: SpecializedAI,
  //   name: "Specialized Assistant",
  //   desc: "Expert-calibrated AI for niche domains and decisions.",
  //   link: false,
  //   link2: false,
  //   hasBanner: false,
  //   githubOnly: false,
  //   hideButtons: true,
  // },
  // {
  //   image: tutorAI,
  //   name: "Coaching Assistant",
  //   desc: "Deliver feedback, track goals, and scale coaching support.",
  //   link: false,
  //   link2: false,
  //   hasBanner: false,
  //   githubOnly: false,
  //   hideButtons: true,
  // },
  // {
  //   image: CustomerServiceAI,
  //   name: "Customer Service Assistant",
  //   desc: "Answer questions, handle FAQs, and improve satisfaction automatically.",
  //   link: false,
  //   link2: false,
  //   hasBanner: false,
  //   githubOnly: false,
  //   hideButtons: true,
  // },
  {
    image: landscapeImg,
    name: "Landscapers & Lawn Care",
    desc: "Showcase services, schedule jobs, and grow local reach.",
    link: false,
    link2: false,
    hasBanner: false,
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: cleaningHomecare,
    name: "Professional Cleaning Services",
    desc: "Let clients book, review, and recommend with ease.",
    link: false,
    link2: false,
    hasBanner: false,
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: electricianHandyman,
    name: "Handymen & Electricians",
    desc: "Automate job intake, estimate quotes, and upsell services.",
    link: false,
    link2: false,
    hasBanner: false,
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: mechanicRepairman,
    name: "Automotive Professionals",
    desc: "Streamline repair scheduling and offer real-time service updates.",
    link: false,
    link2: false,
    hasBanner: false,
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: authorWriter,
    name: "Book Authors & Illustrators",
    desc: "Grow your digital footprint and convert readers into fans.",
    link: false,
    link2: false,
    hasBanner: false,
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  // {
  //   image: artistCreators,
  //   name: "Visual Artists & Creators",
  //   desc: "Build your brand, sell more prints, and connect with buyers.",
  //   link: false,
  //   link2: false,
  //   hasBanner: false,
  //   githubOnly: false,
  //   hideButtons: true,
  // },
  {
    image: showcaseRealEstate,
    name: "Real Estate Agents",
    desc: "Automate lead gen, manage listings, and close faster.",
    link: false,
    link2: false,
    hasBanner: false,
    githubOnly: false,
    hideButtons: true,
    showInquire: true, // ← NEW
  },
  {
    image: LawIMG,
    name: "AI Legal Aid",
    desc: "Summarizes documents, manages legal tasks, and boosts research efficiency for paralegals.",
    link: "https://github.com/jrq3rq/AI-chrome-ext",
    link2: false,
    hasBanner: true,
    bannerText: "Browser Extension",
    githubOnly: true,
  },
  {
    image: TheArchetypeBrandTransformer,
    name: "Branding & Marketing GPT",
    desc: "Crafts standout brand identities using design, archetypes, and strategy.",
    link: "https://chat.openai.com/g/g-SXTcCxFtV-archetype-brand-transformer",
    hasBanner: false,
    bannerText: "Custom GPT",
    githubOnly: false,
  },
  {
    image: NewStorySpinnerLogo,
    name: "Story Spinner",
    desc: "Transform classic stories into fresh, original narratives with AI remixing.",
    link: "https://chat.openai.com/g/g-7T3hhDJO7-storyspinner",
    hasBanner: false,
    bannerText: "Custom GPT",
    githubOnly: false,
  },
  {
    image: RebelAdvisorIMG,
    name: "Rebel Advisor",
    desc: "Provides honest, critical feedback to refine and stress-test your ideas.",
    link: "https://chat.openai.com/g/g-KjtcrDj33-rebel-advisor",
    hasBanner: false,
    bannerText: "Custom GPT",
    githubOnly: false,
  },
  {
    image: BusinessRebrandingTool,
    name: "Business Rebranding Tool",
    desc: "Discover new naming angles—from logical extensions to wild reinventions.",
    link: "https://chat.openai.com/g/g-np3Dj7gOE-business-rebranding-tool",
    hasBanner: false,
    bannerText: "Custom GPT",
    githubOnly: false,
  },
  {
    image: StrategicBusinessPlanner,
    name: "Strategic Business Partner",
    desc: "Run SWOTs, explore pivots, and clarify strategy on demand.",
    link: "https://chat.openai.com/g/g-3aqW0lmMT-strategic-business-partner",
    hasBanner: false,
    bannerText: "Custom GPT",
    githubOnly: false,
  },
];

// --- Component ---
export default function ReactSectionCards() {
  const openLink = (url) => {
    if (url) {
      const win = window.open(url, "_blank");
      if (win) win.document.body.style.backgroundColor = "black";
    }
  };

  return (

    <Section id="ReactSectionCards">
      <div className="ReactSectionCards">
        {data.map((service, index) => {

          // === VIDEO CARD ===
          if (service.videoSrc) {
            return (
              <VideoCard
                key={index}
                videoSrc={service.videoSrc}
                poster={service.image}
                name={service.name}
                desc={service.desc}
                link={service.link}
                link2={service.link2}
                hasBanner={service.hasBanner}
                bannerText={service.bannerText}
                githubOnly={service.githubOnly}
                hideButtons={service.hideButtons}
                onLinkClick={openLink}
              />
            );
          }

          // === IMAGE CARD ===
          return (
            <div
              className="service"
              key={index}
              style={
                service.isFeatured
                  ? {
                      border: '2px solid #44fd47',
                      transform: 'scale(1.02)',
                      zIndex: 10,
                      position: 'relative'
                    }
                  : {}
              }
            >

              <div className="image">
                {service.hasBanner ? (
                  <BannerContainer>
                    <Banner
                      backgroundColor={
                        service.bannerText === "Free Tool" || service.isFeatured
                          ? "#44fd47"
                          : service.bannerText === "Concept"
                          ? "#9D4EDD"
                          : service.bannerText === "Web App"
                          ? "#ffe501"
                          : service.bannerText === "API"
                          ? "#00C2FF"
                          : service.bannerText === "For $ale"
                          ? "#FF0000"
                          : service.bannerText === "Custom GPT"
                          ? "#32CD32"
                          : "#ff2d55"
                      }
                      textColor={
                        service.isFeatured || service.bannerText === "Free Tool"
                          ? "#000000"
                          : service.bannerText === "Web App"
                          ? "#000"
                          : "#ffffff"
                      }
                      style={{
                        fontWeight: service.isFeatured ? 900 : 600,
                        fontSize: service.isFeatured ? '1rem' : '0.85rem',
                        letterSpacing: service.isFeatured ? '1.5px' : '0.5px',
                        textTransform: service.isFeatured ? 'uppercase' : 'none',
                      }}
                    >
                      {service.bannerText || "Tool"}
                    </Banner>
                    <img src={service.image} alt={service.name} />
                  </BannerContainer>
                ) : (
                  <img src={service.image} alt={service.name} />
                )}
              </div>

              <CardInfo
                style={
                  service.isFeatured
                    ? {
                        fontWeight: '900',
                        background: 'linear-gradient(90deg, #44fd47, #a8ffaa)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                      }
                    : {}
                }
              >
                {service.name}
              </CardInfo>

              <div
                className="description-container"
                style={service.isFeatured ? { minHeight: '6.5rem' } : {}}
              >
                <Description
                  style={
                    service.isFeatured
                      ? { fontSize: '0.8rem', color: '#ddffdd' }
                      : {}
                  }
                >
                  {service.desc}
                </Description>
              </div>

              <ButtonContainer>
                {!service.hideButtons && (
                  <StyledButton
                    style={
                      service.isFeatured || service.useFeaturedButton
                        ? {}   // ★★★★★ STYLE REMOVED HERE ★★★★★
                        : {}
                    }
                    onClick={() => openLink(service.link)}
                  >

                    {
                      service.isFeatured || service.useFeaturedButton
                        ? "Try Out"
                        : service.name === "Homeschool Guide AI"
                        ? "View Live"
                        : service.name === "AI Chatbot Templates"
                        ? "Buy Now"
                        : service.name === "AI Chatbots for Small Businesses"
                        ? "Buy Now"
                        : service.githubOnly
                        ? "GitHub"
                        : service.downloadOnly
                        ? "Download"
                        : service.freeTrial
                        ? "Free Trial"
                        : service.bannerText === "Custom GPT"
                        ? "Try Out"
                        : "Preview"
                    }

                  </StyledButton>
                )}
                {/* NEW: Inquire Button — same style, only when showInquire: true */}
                {service.showInquire && (
                  <StyledButton
                    className="inquire-btn"
                    onClick={() => handleInquire(service.name)}
                  >
                    Inquire
                  </StyledButton>
                )}
                {!service.isFeatured && service.link2 && (
                  <StyledButton as="div" onClick={() => openLink(service.link2)}>
                    Download
                  </StyledButton>
                )}
              </ButtonContainer>

            </div>
          );
        })}
        </div>
    </Section>
  );
}
